<div *ngIf="customer.identStatus == identStatus.success"
     class="badge"
     [class.compact]="compact"
     [style.color]="'white'"
     [style.background-color]="'#8bc34a'">
  IDENT
</div>
<div *ngIf="customer.identStatus == identStatus.fail"
     class="badge"
     [class.compact]="compact"
     [style.color]="'white'"
     [style.background-color]="'red'">
  IDENT
</div>
<div matTooltip="Ident pending" *ngIf="customer.identStatus == identStatus.pending"
     class="badge badge-dashed"
     [class.compact]="compact"
     [style.color]="'orange'"
     [style.border-color]="'orange'">
  IDENT
</div>

<div matTooltip="Address confirmed" *ngIf="customer.addressStatus == addressStatus.Confirmed"
     class="badge"
     [class.compact]="compact"
     [style.color]="'white'"
     [style.background-color]="'#8bc34a'">
  ADDR
</div>
<div matTooltip="Address waiting for documents" *ngIf="customer.addressStatus == addressStatus.WaitingForDocuments"
     class="badge"
     [class.compact]="compact"
     [style.color]="'black'"
     [style.background-color]="'orange'">
  ADDR
</div>
<div matTooltip="Address pending check" *ngIf="customer.addressStatus == addressStatus.PendingCheck"
     class="badge"
     [class.compact]="compact"
     [style.color]="'black'"
     [style.background-color]="'yellow'">
  ADDR
</div>
<div matTooltip="Address unconfirmed" *ngIf="customer.addressStatus == addressStatus.Unconfirmed"
     class="badge"
     [class.compact]="compact"
     [style.color]="'white'"
     [style.background-color]="'red'">
  ADDR
</div>

<div matTooltip="No PEP match" *ngIf="customer.pepStatus == pepStatus.noMatch || customer.pepStatus == pepStatus.falsePositive"
     class="badge badge-dashed"
     [class.compact]="compact"
     [style.color]="'#8bc34a'"
     [style.border-color]="'#8bc34a'">
  PEP
</div>
<div matTooltip="PEP check pending" *ngIf="customer.pepStatus == pepStatus.pending"
     class="badge badge-dashed"
     [class.compact]="compact"
     [style.color]="'darkgray'"
     [style.border-color]="'yellow'">
  PEP
</div>
<div matTooltip="PEP possible match" *ngIf="customer.pepStatus == pepStatus.possibleMatch"
     class="badge"
     [class.compact]="compact"
     [style.color]="'white'"
     [style.background-color]="'orangered'">
  PEP
</div>
<div matTooltip="PEP confirmed match" *ngIf="customer.pepStatus == pepStatus.confirmedMatch"
     class="badge"
     [class.compact]="compact"
     [style.color]="'white'"
     [style.background-color]="'red'">
  PEP
</div>

<div matTooltip="SOF present" *ngIf="!hideSof && customer.identLevel == identLevel.Edd"
     class="badge"
     [class.compact]="compact"
     [style.color]="'white'"
     [style.background-color]="'#8bc34a'">
  SOF
</div>
<div matTooltip="SOF missing" *ngIf="!hideSof && customer.identLevel != identLevel.Edd"
     class="badge badge-dashed"
     [class.compact]="compact"
     [style.color]="'darkgray'"
     [style.border-color]="'lightgray'">
  SOF
</div>

<div *ngIf="customer.identLevel == identLevel.Edd"
     class="badge"
     [class.compact]="compact"
     [style.color]="'white'"
     [style.background-color]="'#4a8dc3'">
  EDD
</div>
<div *ngIf="customer.identLevel == identLevel.Fdd"
     class="badge"
     [class.compact]="compact"
     [style.color]="'white'"
     [style.background-color]="'#8bc34a'">
  FDD
</div>
<div *ngIf="customer.identLevel == identLevel.Sdd"
     class="badge"
     [class.compact]="compact"
     [style.color]="'black'"
     [style.background-color]="'#ffec2a'">
  SDD
</div>
<div matTooltip="Ident pending..." *ngIf="!customer.identLevel"
     class="badge badge-dashed"
     [class.compact]="compact"
     [style.color]="'darkgray'"
     [style.border-color]="'#ffec2a'">
  SDD
</div>

<div *ngIf="!hideRisk && customer.riskLevel == 0"
     class="badge"
     [class.compact]="compact"
     [style.color]="'white'"
     [style.background-color]="'#8bc34a'">
  Low risk
</div>
<div *ngIf="!hideRisk && customer.riskLevel == 1"
     class="badge"
     [class.compact]="compact"
     [style.color]="'white'"
     [style.background-color]="'orange'">
  Medium risk
</div>
<div *ngIf="!hideRisk && customer.riskLevel == 2"
     class="badge"
     [class.compact]="compact"
     [style.color]="'white'"
     [style.background-color]="'red'">
  High risk
</div>

<div *ngIf="!hideVulnerable && customer.isVulnerable"
     class="badge"
     [class.compact]="compact"
     [style.color]="'black'"
     [style.background-color]="'orange'"
     [matTooltip]="customer.vulnerableReason"
>
  Vulnerable
</div>
